import { render, staticRenderFns } from "./alteracionPeriodontal.vue?vue&type=template&id=22dfe2b1&"
import script from "./alteracionPeriodontal.vue?vue&type=script&lang=js&"
export * from "./alteracionPeriodontal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports